import { render, staticRenderFns } from "./presserlAccountDeletion.vue?vue&type=template&id=10a9f0ce&"
import script from "./presserlAccountDeletion.vue?vue&type=script&lang=js&"
export * from "./presserlAccountDeletion.vue?vue&type=script&lang=js&"
import style0 from "./presserlAccountDeletion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports